// @version: 1.0.4
export * from '../../services/errorMessages/error-messages.model'


export enum VALIDATORS {
   past = 'onlyPast',
   future = 'onlyFuture',
   range = 'range',
   relative = 'relativeDate',
   required = 'required',
   pattern = 'pattern',
   email = 'email',
   positiv = 'pos',
   negativ = 'neg',
   max = 'maxlength',
   min = 'minlength',
   maxnumber = 'max',
   minnumber = 'min',
   valid = 'valid',
   maxlength = 'maxlength',
   decimal = 'decimal',
   datepickerParse= 'matDatepickerParse'
}

export enum COLOR {
   DEFAULT = 'default',
   PRIMARY = 'primary',
   SUCCESS = 'success',
   ACCENT = 'accent',
   ERROR = 'warn',
   DISABLED = 'disabled',
   WARNING = 'warning',
   HIGH = 'high',
   MEDIUM = 'medium',
   TEXT = 'text'
}

export enum ITEMTYPE {
   text = 'text',
   legend = 'legend',
   titleOne = 'title_one',
   divider = 'divider',
   titleSecond = 'title_second',
   textInput = 'text_input',
   textarea = 'textarea',
   email = 'email',
   number = 'number',
   date = 'date',
   checkbox = "checkbox",
   radio = 'radio',
   combofield = 'combofield',
   rating = 'rating',
   toggle = 'toggle',
   row = 'row',
   download  ='download-link',
   link = 'link-button',
   allToggleFunction = "all-toggle-function",
   imgText = 'img-text',
   fileuploadButton = 'fileupload-button',
   autocomplete = 'autocomplete'
}



export enum POSITION {
   DEFAULT = 'default',
   CENTER = 'center',
   LEFT = 'left',
   RIGHT = 'right'
}

export enum ROWPOSITION {
   column = 'column-field-item',
   row = 'row-field-item'
}

export enum DIRECTION {
   HORIZONTAL = 'horizontal',
   VERTICAL = 'vertical'
}

export enum DESIGN_MODE {
   CLEAN = 0,
   TILE
}

export enum FIELD_DESIGN_MODE {
   FILL = 0,
   OUTLINE
}

export enum CONTAINER {
   SMALL = 0,
   MEDIUM,
   LARGE
}

export enum SHOWTYPE {
   QUESTIONLIST = 0,
   SUCCESSDIALOG = 1,
   BOTH = 2
}

export interface IFieldItem {
   valid?: string;
   required?: boolean;
   attribute_1?: string;
   attribute_2?: string;
   attribute_3?: string;
   attribute_4?: string;
   attribute_5?: string;
   attribute_6?: string;
   placeholder?: string; 
   content?: string;
}

export interface IMetaData {
   id: string;
   disabled?: boolean;
   fieldtype: ITEMTYPE;
}

export interface IUploadFileData {
   size: number;
   lfnr: number;
   url: string; 
   mimeType?: string;
   file?: string | null;
   filename?: string;
   fileBlob: Blob;
   fileExtension: string;
}

export interface IMetaContent {
   id: string;
   fieldtype?: string;
   question_id: string;
   showType: SHOWTYPE;
   sort: number;
   content: string | IUploadFileData[];
   noData: boolean;
   send: boolean;
}

export interface IRowValue {
   content?: string;
   preferred?: boolean;
}

export interface IFunction {
   type: string; 
   value: string; 
}